// extracted by mini-css-extract-plugin
module.exports = {"thead":"_goalprogresstable_thead__2o-iM","tbody":"_goalprogresstable_tbody__z8vdw","row":"_goalprogresstable_row__MEhr4"};